import { useEffect, useState } from "react"
import { Panel, Modal } from "react-bootstrap";
import { fetchApi } from "../../Network/NetworkService";
import dateFormat from 'dateformat';
import moment from 'moment';
import IconTooltip from '../Ui/IconTooltip';
import { notif } from '../Ui/Notification';


const RelanceHistory = (props) => {
    const [relanceHist, setRelanceHist] = useState({ newHist: [], oldHist: []})
    const [dateHistSel, setDateHistSel] = useState(new Map())
    const [docHistSel, setDocHistSel] = useState(new Set())
    const [userLoading, setUserLoading] = useState(false);

    const getRelanceHist = (id, dateId) => {
            
        setUserLoading(true)
        fetchApi(`/campagne-sdr/relanceHistory${id ? `/${id}` : ''}${dateId ? `?dateId=${dateId}` : ''}`)
        .then((res) => {
            if (!id) {
                setRelanceHist(res.history)
            }
            else {
                const arr = new Map(dateHistSel);
                if (arr.has(dateId)) {
                    arr.delete(dateId)
                }
                else arr.set(dateId, { id, show: true, users: res.users, page: 1, countPage: res.countPage, countNewReq: res.countNewReq })

                setDateHistSel(arr)
            }
            setUserLoading(false);
        })
        .catch((e) => {
            console.log(e);
            
            notif.addNotification(
                'Erreur',
                'Erreur de recuperation',
                'warning'
            )
            setUserLoading(false);
        });
    }

    const renderUserData = (id, cAt) => {
    
            const obj = dateHistSel.get(id)
            
            
            const { page, countPage: totalPage, users, countNewReq } = obj        
    
            const indexOfLastRow = page * 10;
            const indexOfFirstRow = indexOfLastRow - 10;
    
            
            const currentRows = users.slice(indexOfFirstRow, indexOfLastRow);
    
    
            return (
                <>
                    <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                        <p style={{ margin: 0}}>
                        Liste des utilisateurs (Page <strong>{page}</strong> /{' '}
                            {totalPage})
                        </p>
    
                        <IconTooltip
                            icon="fa fa-chevron-left"
                            text="Page précédente"
                            disabled={page < 2}
                            onClick={() => {
                                const arr = new Map(dateHistSel);    
                                
                                const obj = arr.get(id)
    
                                obj.page -= 1
    
                                arr.set(id, obj)
    
                                setDateHistSel(arr)
                            }}
                        />
                        <IconTooltip
                            icon="fa fa-chevron-right"
                            text="Page suivante"
                            disabled={page === totalPage}
                            onClick={() => {
                                const arr = new Map(dateHistSel);    
                                
                                const obj = arr.get(id)
    
                                obj.page += 1
    
                                arr.set(id, obj)
    
                                setDateHistSel(arr)
                            }}
                        />
                    </div>
                    {cAt && (
                        <div>
                            Date d'envoie : {moment(cAt).format('DD/MM/YYYY')}
                        </div>
                    )}
                    <div>
                        Envoie total : {users.length}
                    </div>
                    <div>
                        Total utilisateur avec nouveau requete : {countNewReq > 0 ? users.length : 0}
                    </div>
                    <div>
                        Total nouveau requete : {countNewReq} {`(${((countNewReq / users.length) * 100).toFixed(0)}%)`}
                    </div>
                    <div className="table-responsive">
                        <table className="table table-hover mb-0">
                            <thead>
                                <tr>
                                    <th>Utilisateur</th>
                                    <th>Email</th>
                                    <th>Date d'inscripton</th>
                                    <th>Nb de nouveau requete</th>
                                    <th>Date de dernier tlc</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentRows.map((r) =>  {
                                    return (
                                        <tr key={r._id}>               
                                            <td> {r.FName} {r.LName}</td>
                                            <td>{r.email}</td>
                                            <td>{dateFormat(r.createdAt, 'dd/mm/yy')}</td>
                                            <td>{r.newReq}</td>
                                            <td>{moment(r.request[0].createdAt).format("DD/MM/YYYY")}</td>
                                            <td>
                                                <IconTooltip
                                                    icon="fas fa-file-medical"
                                                    text="Details"
                                                    onClick={() =>
                                                        props.history.push(
                                                            '/users/detail/' + r._id
                                                        )
                                                    }
                                                />
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </>
            )
        }  
        

    useEffect(() => {
        getRelanceHist()
    }, [])

    const renderHist = (type) => {
        return relanceHist[type].filter((v) => !!v.doctorId).map((v) => (
            <div key={v._id}>
                <p onClick={() => {
                    const arr = new Set(docHistSel);

                    if (arr.has(v.doctorId._id)) {
                        arr.delete(v.doctorId._id)
                    }
                    else arr.add(v.doctorId._id)                                    
                    
                    setDocHistSel(arr)
                }} style={{ marginTop: 10, cursor: 'pointer' }}>
                    {v.doctorId.FName} {v.doctorId.LName} {'>'}
                </p>
                
                {docHistSel.has(v.doctorId._id) && v.date.map((d, idx) => {
                    return (
                        <div key={d._id}>
                            <p onClick={() => {
                                
                                if (!dateHistSel.has(d._id)) {
                                    getRelanceHist(v._id, d._id)
                                }
                                else {
                                    
                                    const arr = new Map(dateHistSel)  

                                    const obj = arr.get(d._id)
                                    
                                    obj.show = !obj.show         

                                    arr.set(d._id, obj)                                                      
                                    
                                    setDateHistSel(arr)
                                }
                            }} style={{ marginTop: 2, cursor: 'pointer' }}>
                                &nbsp; &nbsp; {moment(d.start).format('DD/MM/YYYY')} - {dateFormat(d.end, 'dd/mm/yy')} {'>'} {(d.createdAt[0] && idx === 0) ? "(dernier)" : ""}
                            </p>
                            {dateHistSel.has(d._id) && dateHistSel.get(d._id).show && renderUserData(d._id, d.createdAt[0])}
                        </div>
                    )
                })}
            </div>
        ))
    }

    return (
        <Panel>
            <Modal
                show={userLoading}
                backdrop="static"
                keyboard={false}
                size="lg"
                className="modal-spinner"
            >
                <span className="loader" />
                {userLoading && <p>Récupération des utilisateurs...</p>}
            </Modal>
            <Panel.Heading>
                <h6>Historique des relances</h6>
            </Panel.Heading>
            <Panel.Body>
                <div>
                    <p>Nouvelle relance</p>
                    {renderHist('newHist')}
                </div>
                <div style={{ marginTop: 30 }}>
                    <p>Ancien relance (historique récupérée)</p>
                    {renderHist('oldHist')}
                </div>
            </Panel.Body>
        </Panel>
    )
}

export default RelanceHistory